import { render, staticRenderFns } from "./pendingApproval.vue?vue&type=template&id=1224f947&scoped=true"
import script from "./pendingApproval.vue?vue&type=script&lang=js"
export * from "./pendingApproval.vue?vue&type=script&lang=js"
import style0 from "./pendingApproval.vue?vue&type=style&index=0&id=1224f947&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1224f947",
  null
  
)

export default component.exports